'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeChoroplethmapboxIcon = function TraceTypeChoroplethmapboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', stroke: '#dfe8f3', d: 'M5.5 6H41v35.5H5.5zM5.5 11.2H41M5.5 16.4H41M5.5 21.1H41M5.5 26.3H41M5.5 31.4H41M5.5 36.6H41M10.7 41.4V6M15.8 41.5V6M20.5 41.5V6M25.7 41.5V6M30.9 41.5V6M36 41.5V6', strokeMiterlimit: '10', strokeWidth: '.25' }),
        _react2.default.createElement('path', { d: 'M0 0h46v46H0z', fill: 'none' }),
        _react2.default.createElement('path', { d: 'M31.1 27.4l-2.2 3.3-4.4 1.1-2.2-2.2H19l-6 1.1-3.3-2.2 3.7-4.4v-3.3h5l4 2.9 4.3-2.9 8.9 6.6z', fill: '#27d1f0', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        _react2.default.createElement('path', { d: 'M35.5 27.4l-8.9-6.6-4.3 2.9-4-2.9h-5l-2.8-1.7v-2.2l-1.1-1.1-1.1 1.1-1.1-1.1v-4.4h2.2l2.2-1.1h2.2l3.3 2.2h3.3l4.4-2.2 3.3 3.3-3.1 3.3h5.5v-2.2h3.3v1.1l1.1 1.1 1.1-1.1 3.3 3.3v3.3h-3.9v5zm-9.4 7.2L25 35.7h-1.1l.6-3.9-2.2-2.2H19l-6 1.1 7.6 3.9v2.2l3.3 2.2h2.2l1.1-1.1v-2.2z', fill: '#1d9bfb', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round' })
    );
};

exports.default = TraceTypeChoroplethmapboxIcon;